import { render, staticRenderFns } from "./DocumentVideo.vue?vue&type=template&id=19257ef3"
import script from "./DocumentVideo.vue?vue&type=script&lang=js"
export * from "./DocumentVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports